import React, { Component } from 'react';
import hoistStatics from 'hoist-non-react-statics';

const Poller = onInterval => WrappedComponent => {
  class PollingHoC extends Component {
    schedule(time) {
      this.interval = setTimeout(() => onInterval(this.props, this.schedule.bind(this)), time);
    }

    componentDidMount() {
      onInterval(this.props, this.schedule.bind(this));
    }

    componentWillUnmount() {
      clearTimeout(this.interval);
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }
  return hoistStatics(PollingHoC, WrappedComponent);
};

export default Poller;
